import { Injectable } from '@angular/core';
import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { SystemControlService} from './system-control.service';
import {SystemControlElem} from './system-control-elem';

/*@Component({
    //templateUrl: 'app/system-management/growth-rates/growth-rates-save/growth-rates-save.component.html',
    template:`<div></div>`,
    directives: [ROUTER_DIRECTIVES],
    providers:[SystemControlService]
    
})*/
@Injectable()
export class SystemControl  {
    public fyYear: number;
    public ffcYear: number;
    public lfcYear:number;
    public mangrLock:number;
    public importStage:number;
    errorMessage: string;
    systemControlElem:SystemControlElem
   
    
    constructor(private  _systemControlService:SystemControlService){
          this.callService();
    }
    private callService(){
        this._systemControlService.getSystemControl()
            .subscribe(
            systemControlElem => this.systemControlElem = systemControlElem,
            error => this.errorMessage = <any>error,
            ()=>{

                this.fyYear = this.systemControlElem.fyYear;
                this.ffcYear = this.systemControlElem.ffcYear;
                this.importStage = this.systemControlElem.importStage;
                this.lfcYear = this.systemControlElem.lfcYear;
                this.mangrLock = this.systemControlElem.mangrLock;
            }
            );
     }
     /*public getFyYear():number{
         //alert("getFyYear "+ typeof(this.fyYear) == undefined );
        // if(this.fyYear == null){
             this.callService();
        // }
         return this.fyYear;
     }*/
}



/** WEBPACK FOOTER **
 ** ./app/shared/system-control.ts
 **/